export interface ISendExampleEmailInput {
    includeEstimatedArrival: boolean;
    includeScheduledArrival: boolean;
    notificationMargin: boolean;
}
